if (!customElements.get('quick-quote')) {
  class QuickQuote extends HTMLElement {
    constructor() {
      super();

      //options
      this.options = parseJson(this.dataset.options).productOptions;

      // elements
      this.productOptions = this.querySelectorAll('fieldset');

      // event listeners
      this.querySelectorAll('[data-option-label]').forEach((radio) => {
        radio.addEventListener('click', () => this.handleChange(radio));
      });
    }

    handleChange(radio) {
      const trigger = radio.closest('fieldset').querySelector('[data-collapsible-trigger]');

      const optionIndex = parseInt(radio.closest('fieldset').dataset.optionGroup);
      const newOptionValue = radio.dataset.optionTitle;

      this.options[optionIndex] = newOptionValue;

      trigger.querySelector('[data-current-variant]').innerHTML = radio.innerHTML;
      trigger.toggle();
    }
  }

  window.QuickQuote = QuickQuote;
  customElements.define('quick-quote', QuickQuote);
}
